// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css'; // このパスが正しいことを確認
import './utils/axiosConfig';  // axios設定を初期化
import App from './App';

// アプリ起動時に古い認証データをクリーンアップ
// Cookie認証に移行したため、LocalStorageの古いトークンデータは不要
const cleanupLegacyAuthData = () => {
  const legacyKeys = ['token', 'userId', 'user'];
  let cleanedCount = 0;

  legacyKeys.forEach(key => {
    if (localStorage.getItem(key)) {
      console.log(`[Cleanup] Removing legacy auth data: ${key}`);
      localStorage.removeItem(key);
      cleanedCount++;
    }
  });

  if (cleanedCount > 0) {
    console.log(`[Cleanup] Cleaned up ${cleanedCount} legacy auth data item(s)`);
  }
};

cleanupLegacyAuthData();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);